<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    :title="isAdd ? '新增部门' : '编辑部门'"
    :enableDrag="true"
    width="500px"
    @close="cancel">
    <dynamic-form :formConfig="formConfig" v-model="form" @submit="doSubmit" @cancelForm="cancel" ref="pageForm"></dynamic-form>
  </drag-dialog>
</template>

<script>
import { add, edit } from '@/api/dept'
import DragDialog from '@/components/DragDialog'
import '@/components/dynamic-form';
import { getDeptTree } from "@/api/dept";
export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true
    },
    treeData: {
        type: Array,
        default: () => ([])
    },
    supThis: {
      type: Object,
    }
  },
  components: {
    DragDialog
  },
  data() {
    return {
      loading: false, dialog: false,
      form: {},
      formConfig: {
        formItemList: [
            {
              type: "input",
              key: "name",
              label: "组织名称",
              placeholder: "请输入名称",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "input",
              key: "code",
              label: "组织编码",
              placeholder: "请输入编码",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
                label: '上级组织',
                key: 'parentId',
                type: 'treeSelect',
                multiple: false,
                clearable: true,
                props: {
                    children: 'children',
                    label: 'name',
                    value: 'id'
                }
            },
            // {
            //     type: "radio",
            //     label: "是否启用",
            //     span: 12,
            //     key: "enabled",
            //     dicType: "ENABLE_STATUS",
            //     optionsUrl: "/dict-detail",
            //     rules: [{required: true,trigger: "change"}]
            // },
             {
                type: "radio",
                label: "是否启用",
                value: true,
                button: false,
                border: false,
                key: "enabled",
                options: [
                    {
                        label: '启用',
                        value: true
                    },
                    {
                        label: '禁用',
                        value: false
                    }
                ],
                rules: [{required: true,trigger: "change"}]
            },
            {
                type: 'number',
                label: '排序号',
                key: 'sorting',
                placeholder: '请输入数字'
            }
        ]
      }
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.pageForm.$refs.dynamicForm.clearValidate();
        });
        const index = this.formConfig.formItemList.findIndex(i => i.key === 'parentId')
        if (this.form.id) {
          this.$set(this.formConfig.formItemList[index], 'disabledValue', [this.form.id])
        } else {
          this.$set(this.formConfig.formItemList[index], 'disabledValue', [-1])
        }
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.getDeptTree();
    });
  },
  methods: {
    async getDeptTree() {
        await getDeptTree().then(res => {
            this.$set(this.formConfig.formItemList[2], 'options', res.data || [])
        });
    },
    cancel() {
        this.resetForm();
    },
    doSubmit(val) {
        this.form = val
        if (this.isAdd) {
            this.doAdd();
        } else this.doEdit();
    },
    doAdd() {
        add(this.form)
            .then(res => {
                this.resetForm();
                this.$notify({
                    title: "添加成功",
                    type: "success",
                    duration: 2500
                });
                this.loading = false;
                this.supThis.dataTableInit();
                this.getDeptTree();
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            });
    },
    doEdit() {
        edit(this.form)
            .then(res => {
                this.resetForm();
                this.$notify({
                    title: "修改成功",
                    type: "success",
                    duration: 2500
                });
                this.loading = false;
                this.supThis.dataTableInit();
            })
            .catch(err => {
                this.loading = false;
                console.log(err.response.data.message);
            });
    },
    resetForm() {
        this.dialog = false;
        this.$refs.pageForm.resetForm();
    }
  }
}
</script>

<style scoped>

</style>
